import cn from 'classnames';

import { CloseBtn } from '@webapp/common/components/close-btn';
import { CssUiComponent } from '@webapp/common/components/survey-custom';
import { useToggle } from '@webapp/common/hooks/use-toggle';

import css from './account-notice.css';

export const AccountNotice: FC<{
    content: ReactNode;
    closable?: boolean;
}> = ({ closable = false, content }) => {
    const { enabled, off } = useToggle(true);

    if (!enabled) {
        return null;
    }

    return (
        <div className={cn(css.notice, CssUiComponent.NO_PRINT)}>
            {closable && <CloseBtn onClick={off} />}
            {content}
        </div>
    );
};
